import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '@federico.moretti/react-translate';
import { CircleStatus, StyledStatusLabel } from './styles';

const StatusLabel = ({ status, type, style }) => {
  const { t } = useTranslate();

  const statusString = {
    // user
    Lead: t('statuses.user.Lead'),
    Deleted: t('statuses.user.Deleted'),
    //
    Open: t('statuses.user.Open'),
    // portfolio
    Created: t('statuses.portfolio.Created'),
    Financed: t('statuses.portfolio.Financed'),
    OnTrack: t('statuses.portfolio.OnTrack'),
    OffTrack: t('statuses.portfolio.OffTrack'),
    // account
    Profiled: t('statuses.account.Profiled'),
    AcceptedProposal: t('statuses.account.AcceptedProposal'),
    WaitingContractSignature: t('statuses.account.WaitingContractSignature'),
    SignedContract: t('statuses.account.SignedContract'),
    Active: t('statuses.account.Active'),
    Suspended: t('statuses.account.Suspended'),
    OnboardingInProgress: t('statuses.OnboardingInProgress'),
    //
    Draft: t('statuses.account.Draft'),
    Opening: t('statuses.account.Opening'),
    // lead
    New: t('statuses.lead.New'),
    InProgress: t('statuses.lead.InProgress'),
    Connected: t('statuses.lead.Connected'),
    Unqualified: t('statuses.lead.Unqualified'),
  };

  return (
    <StyledStatusLabel style={style}>
      <CircleStatus status={status} type={type} />
      {statusString[status] || status}
    </StyledStatusLabel>
  );
};

StatusLabel.propTypes = {
  style: PropTypes.object,
  type: PropTypes.string,
  status: PropTypes.string,
};

export default React.memo(StatusLabel);
